export const HeaderData = [

    {
        menu:"Home",
        link:"/",
     },
     {
        menu:"Programs",
        link:"/#",
        submenu:true,
      subMenuitem:[
         {
             subItem:"All programs",
             linkL:"/causes",
         },
        
         {
             subItem:"Program details",
             linkL:"/cause-details",
         },
        ]
     },
     {
        menu:"Events",
        link:"/#",
        submenu:true,
      subMenuitem:[
         {
             subItem:"Events",
             linkL:"/event",
         },
        
         {
             subItem:"Event details",
             linkL:"/event-details",
         },
        ]
     },
     {
        menu:"Gallery",
        link:"/gallery",
     },
     {
        menu:"News",
        link:"/#",
        submenu:true,
      subMenuitem:[
         {
             subItem:"News",
             linkL:"/news",
         },
        
         {
             subItem:"News details",
             linkL:"/news-details",
         },
        ]
     },
     {
        menu:"Pages",
        link:"/#",
        submenu:true,
      subMenuitem:[
         {
             subItem:" About",
             linkL:"/about",
         },
        
         {
             subItem:"Support PCF",
             linkL:"/make-donation",
         },
         {
             subItem:"Testimonials",
             linkL:"/testimonial",
         },
         {
             subItem:"Our team",
             linkL:"/team",
         },
         {
             subItem:"Login",
             linkL:"/login",
         },
         {
             subItem:"Register",
             linkL:"/register",
         },
         {
             subItem:"FAQ",
             linkL:"/faqs",
         },
         {
             subItem:"Image asset guide",
             linkL:"/image-guide",
         },
         {
             subItem:"Privacy Policy",
             linkL:"/privacy-policy",
         },
         {
             subItem:"Terms of service",
             linkL:"/terms-service",
         },
         {
             subItem:"404 Error",
             linkL:"*",
         },
        ]
     },
   
     {
        menu:"Contact",
        link:"/contact",
     },
]
